import { useEffect } from 'react';

// Define a global breadcrumb context
type BreadcrumbContext = {
  customTitle?: string;
};

// Create a global object to store breadcrumb context
const breadcrumbContext: { [path: string]: BreadcrumbContext } = {};

/**
 * Custom hook for managing breadcrumbs
 * @param customTitle Optional custom title to display in the breadcrumb
 */
const useBreadcrumbs = (customTitle?: string) => {
  const path = window.location.pathname;
  
  useEffect(() => {
    // Set custom title for this path if provided
    if (customTitle) {
      breadcrumbContext[path] = { customTitle };
    }
    
    // Cleanup when component unmounts
    return () => {
      delete breadcrumbContext[path];
    };
  }, [path, customTitle]);
  
  return breadcrumbContext;
};

export { useBreadcrumbs, breadcrumbContext }; 